import type { TRACKER_TYPES } from '@racemap/sdk/schema/trackers';
import { useLocation } from 'react-router';

export const useTrackerParams = () => {
  const location = useLocation();
  const urlParams = new URLSearchParams(location.search);
  const deviceType = urlParams.get('deviceType') as TRACKER_TYPES | null;
  const appId = urlParams.get('appId');
  const deviceName = urlParams.get('deviceName');
  return { deviceType, appId, deviceName };
};
